<div class="list">
	@if (persons().length > 0) {
		@for (person of persons(); track person.id) {
			<a class="link" [routerLink]="[person.id]">
				<lvr-institution-persons-item [person]="person"></lvr-institution-persons-item>
			</a>
		}
		<lvr-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="pageIndex()"
			[showFirstLastButtons]="showFirstLastButtons"
			[hidePageSize]="hidePageSize"
			preferenceKey="institution-persons-list"
			(page)="handlePageEvent($event)"
		>
		</lvr-paginator>
	} @else {
		<lvr-institution-persons-item [institutionName]="institutionName()"></lvr-institution-persons-item>
	}
</div>
